const ErrorCodes = {
  axios: {
    CONN_REFUSED: 'ERR_CONNECTION_REFUSED',
    ERR_NETWORK: 'ERR_NETWORK',
  },
}

export default ErrorCodes
